import type { Event } from '@sentry/react';

const IN_APP_BROWSER_NOISE_PATTERNS = [/_AutofillCallbackHandler/, /_META\.IABInnerFrame/];

const exceptionMessages = (event: Event) =>
  (event.exception?.values ?? []).map(({ value }) => value ?? '');

export const isInAppBrowserNoise = (event: Event) =>
  exceptionMessages(event).some(message =>
    IN_APP_BROWSER_NOISE_PATTERNS.some(pattern => pattern.test(message)),
  );
